import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check both localStorage items for consistency
    const isAdminLoggedIn = localStorage.getItem('isAdminLoggedIn') === 'true';
    const adminData = localStorage.getItem('adminData');
    
    if (isAdminLoggedIn && adminData) {
      try {
        setUser(JSON.parse(adminData));
      } catch (error) {
        console.error('Error parsing admin data:', error);
        // Clear invalid data
        localStorage.removeItem('isAdminLoggedIn');
        localStorage.removeItem('adminData');
      }
    }
    setIsLoading(false);
  }, []);

  const isAdmin = !!user;

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('isAdminLoggedIn', 'true');
    localStorage.setItem('adminData', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('isAdminLoggedIn');
    localStorage.removeItem('adminData');
    localStorage.removeItem('adminLoginTime');
  };

  return (
    <AuthContext.Provider value={{ user, isAdmin, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);